import { render, staticRenderFns } from "./OtherCostListFunc.vue?vue&type=template&id=55f81bbb&scoped=true"
import script from "./OtherCostListFunc.vue?vue&type=script&lang=js"
export * from "./OtherCostListFunc.vue?vue&type=script&lang=js"
import style0 from "./OtherCostListFunc.vue?vue&type=style&index=0&id=55f81bbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f81bbb",
  null
  
)

export default component.exports